import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { GeoPricingProvider } from './geo/GeoPricingContext';
import reportWebVitals from './reportWebVitals';
import faviconLogo from './Assets/favicon-logo.jpg';

const setSiteIcons = () => {
  const ensureLink = (selector, relValue) => {
    let link = document.head.querySelector(selector);
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', relValue);
      document.head.appendChild(link);
    }
    link.setAttribute('href', faviconLogo);
    link.setAttribute('type', 'image/jpeg');
    return link;
  };

  ensureLink('link[rel="icon"]', 'icon');
  ensureLink('link[rel="apple-touch-icon"]', 'apple-touch-icon');
};

setSiteIcons();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GeoPricingProvider>
      <App />
    </GeoPricingProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
